import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AI_FUNCTION_FORM_CONFIG } from './create-ai-function-utils';
import { RappiderEditFormModule, RappiderTitleToolbarModule } from '@rappider/rappider-components';
import { BreadcrumbOption, HeadingComponentConfig } from '@rappider/rappider-components/utils';
import { defaultToolbarTitleHeadingSize } from '@rappider/shared/definitions';
import { Store } from '@ngrx/store';
import { CreateAIFunction } from '../../state/ai-assistant.actions';

@Component({
  selector: 'rappider-create-ai-function',
  standalone: true,
  imports: [
    RappiderEditFormModule,
    RappiderTitleToolbarModule
  ],
  templateUrl: './create-ai-function.component.html',
  styleUrls: ['./create-ai-function.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateAiFunctionComponent {

  isLoading = false;

  mainTitleConfig: HeadingComponentConfig = {
    content: 'Add AI Function',
    type: defaultToolbarTitleHeadingSize
  };

  titleBreadCrumbItems: BreadcrumbOption[] = [];

  AI_FUNCTION_FORM_CONFIG = AI_FUNCTION_FORM_CONFIG;

  constructor(
    private store: Store<any>
  ) { }


  saveAiFunction(event: any) {
    console.log('saveAiFunction', event);
    this.store.dispatch(CreateAIFunction({
      payload: {
        aiFunctionCall: {
          name: event.name,
          description: event.description,
          systemPrompt: event.systemPrompt,
          functionPrompt: event.functionPrompt,
          responseJsonSample: event.responseJsonSample,
          postWorkflowStepFunctionId: event.postWorkflowStepFunctionId,
        }
      }
    }));
  }


}
